import * as React from 'react';
import { Col, Row } from 'reactstrap';
import { getMyTours, MyToursPageDto } from '../../../../../api/MyTours';
import { useFetch } from '../../../../../hooks/useFetch';
import { PreferredTourFormat, TourStatuses } from '../../../../../utilities/Enums';
import FormValidationDisplay from '../../../../common/form/ValidationDisplay';
import LoadingOverlay from '../../../../common/LoadingOverlay';
import IndividualTourDisplay from './IndividualTourDisplay';

interface MyToursPageSection {
    title: string;
    subtitle?: string;
    filterFn: (t: MyToursPageDto) => boolean;
}

const MyToursPage = () => {
    const {
        data: toursData,
        loading: isLoading,
        error: errorMessage
    } = useFetch<MyToursPageDto[], MyToursPageDto[]>(
        () => getMyTours(),
        [],
        [] as MyToursPageDto[]
    );

    const checkForStatuses = (statuses: TourStatuses[]) => {
        return (t: MyToursPageDto) =>
            t.tour !== null && t.tour !== undefined && statuses.indexOf(t.tour.tourStatus) !== -1;
    };

    const sections: MyToursPageSection[] = [
        {
            title: 'Scheduled Tours',
            filterFn: checkForStatuses([TourStatuses.Scheduled, TourStatuses.Reminded])
        },
        {
            title: 'Virtual Tours',
            filterFn: t => t.preferredTourFormat === PreferredTourFormat.Virtual
        },
        {
            title: 'Finished Tours',
            filterFn: checkForStatuses([TourStatuses.Finished])
        },
        {
            title: 'Completed Tours',
            filterFn: checkForStatuses([TourStatuses.Complete])
        },
        {
            title: 'Virtual Tours',
            filterFn: t => t.preferredTourFormat === PreferredTourFormat.Virtual
        },
        {
            title: 'Incomplete Signups',
            filterFn: t => t.tour === null && t.preferredTourFormat !== PreferredTourFormat.Virtual
        },
        {
            title: 'Missed Tours',
            filterFn: checkForStatuses([TourStatuses.NoShow])
        },
        {
            title: 'Cancelled Tours',
            filterFn: checkForStatuses([TourStatuses.Cancelled])
        }
    ];

    return (
        <Row>
            <Col size={12}>
                <LoadingOverlay show={isLoading} inBootstrapColumn={true} />
                <FormValidationDisplay errorMessage={errorMessage} />
                <div className="top-spacer" />
                {sections
                    .filter(s => toursData.filter(t => s.filterFn(t)).length > 0)
                    .map((section, sectionIndex) => (
                        <div key={sectionIndex}>
                            <div className="section-header">
                                <label className="title">{section.title}</label>
                                {section.subtitle && (
                                    <label className="subtitle">
                                        <em>{section.subtitle}</em>
                                    </label>
                                )}
                            </div>
                            {toursData
                                .filter(t => section.filterFn(t))
                                .map((tour, tourIndex) => (
                                    <IndividualTourDisplay tourInfo={tour} key={tourIndex} />
                                ))}
                        </div>
                    ))}
            </Col>
        </Row>
    );
};

export default MyToursPage;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/tour/allTours/MyToursPage.tsx